import React, { createContext, useEffect, useState } from 'react'
import { Box, Flex, TertiaryButton, Tooltip } from '@workday/canvas-kit-react'
import { Link } from 'react-router-dom'
import { Confirmation, ConfirmationProps, ScreenWidthCategory, screenWidthCategoryFromWidth, UpdateConfirmation, UpdateToast } from 'pulsepoint-web-common'
import { ToastManager, ToastProps } from './ToastManager'
import { questionOutlineIcon } from '@workday/canvas-system-icons-web'
import styled from '@emotion/styled'

const StyledFlex = styled(Flex)`
  path {
    fill: white !important;
  }

  a:hover {
    path {
      fill: #333 !important;
    }
  }
`

export const ScreenWidthCategoryContext = createContext<ScreenWidthCategory>(ScreenWidthCategory.Medium)
export const ToastContext = createContext<UpdateToast>({
  setMessages: () => {}
})
export const ConfirmationDialogContext = createContext<UpdateConfirmation>({
  setConfirmation: () => {}
})

const AppSkeleton = ({children}: any) => {
  const updateToastMessages = (good: string[], bad: string[]) => {
    setToastMsg({ good: good, bad: bad, onClose: clearToastMsg })
  }

  const clearToastMsg = () => {
    setToastMsg(prev => ({ ...prev, good: [], bad: [] }))
  }

  const [screenWidthCategory, setScreenWidthCategory] = useState<ScreenWidthCategory>(ScreenWidthCategory.Medium)
  const [toastMessage, setToastMsg] = useState<ToastProps>({ good: [], bad: [], onClose: clearToastMsg })
  const [confirmationContext, setConfirmationContext] = useState<ConfirmationProps | null>(null)

  const handleWindowResize = () => {
    setScreenWidthCategory(screenWidthCategoryFromWidth(window.innerWidth))
  }

  useEffect(() => handleWindowResize(), [])
  useEffect(() => {
    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  return (
    <ScreenWidthCategoryContext.Provider value={screenWidthCategory}>
      <ToastContext.Provider value={{ setMessages: updateToastMessages }}>
        <ConfirmationDialogContext.Provider value={{
          setConfirmation: confirmationContext => {
            setConfirmationContext(confirmationContext ?? null)
          }
        }}>
          {confirmationContext != null && (
            <Confirmation
              title={confirmationContext.title}
              message={confirmationContext.message}
              onCancel={() => {
                confirmationContext.onCancel()
                setConfirmationContext(null)
              }}
              confirmLabel={confirmationContext.confirmLabel}
              onConfirm={() => {
                confirmationContext.onConfirm()
                setConfirmationContext(null)
              }}
              addOtherButton={confirmationContext.addOtherButton}
              otherLabel={confirmationContext.otherLabel}
              onOtherButton={() => {
                confirmationContext.onOtherButton && confirmationContext.onOtherButton()
                setConfirmationContext(null)
              }}
            />
          )}
          <ToastManager good={toastMessage.good} bad={toastMessage.bad} onClose={toastMessage.onClose} />
          <Flex flexDirection="column" height="100%">
            <Box
              style={{
                backgroundImage: 'linear-gradient(45deg, rgb(196, 22, 28), rgb(188, 21, 26))'
              }}
              width="100%"
            >
              <StyledFlex flexDirection="row" alignItems='center'>
                <Link to={"/"}>
                  <img src="/images/logo.png" style={{height: "104px", margin: "-20px"}} />
                </Link>
                <Flex flex={1} />
                <Tooltip title="Quick Start Guide">
                  <TertiaryButton 
                    style={{marginRight: '20px'}}
                    icon={questionOutlineIcon} 
                    as="a"
                    href="https://www.pulsepoint.org/respond-for-web"
                    target="_blank" />
                </Tooltip>
              </StyledFlex>
            </Box>
            {children}
          </Flex>
        </ConfirmationDialogContext.Provider>
      </ToastContext.Provider>
    </ScreenWidthCategoryContext.Provider>
  )
}

export default AppSkeleton